import { render, staticRenderFns } from "./BoxInfoStep.vue?vue&type=template&id=090a9ef8&scoped=true"
import script from "./BoxInfoStep.vue?vue&type=script&lang=js"
export * from "./BoxInfoStep.vue?vue&type=script&lang=js"
import style0 from "./BoxInfoStep.vue?vue&type=style&index=0&id=090a9ef8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a9ef8",
  null
  
)

export default component.exports